/******/ var __webpack_modules__ = ({

/***/ "./src/js/modules/header.ts":
/*!**********************************!*\
  !*** ./src/js/modules/header.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* export default binding */ __WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*!
 *
 *  header.ts
 *
 */
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
    var header = document.querySelector('#header');
    var isShrink = false;
    window.addEventListener('scroll', function () {
        var scrollY = window.scrollY;
        if (scrollY > 0 && !isShrink) {
            header.classList.add('-shrink');
            isShrink = true;
        }
        else if (scrollY === 0 && isShrink) {
            header.classList.remove('-shrink');
            isShrink = false;
        }
        ;
    });
}


/***/ }),

/***/ "./src/js/modules/linker.ts":
/*!**********************************!*\
  !*** ./src/js/modules/linker.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Linker)
/* harmony export */ });
function Linker(options) {
    var _a, _b;
    var settings = {
        target: (_a = options === null || options === void 0 ? void 0 : options.target) !== null && _a !== void 0 ? _a : 'a',
        excludedDirectories: (_b = options === null || options === void 0 ? void 0 : options.excludedDirectories) !== null && _b !== void 0 ? _b : [],
    };
    var domain = window.location.hostname;
    var links = Array.from(document.querySelectorAll(settings.target));
    links.forEach(function (link) {
        if (isLinkTargetable(link)) {
            link.setAttribute('target', '_blank');
            if (hasImageElement(link)) {
                link.setAttribute('data-no-icon', 'true');
            }
        }
    });
    function isLinkTargetable(link) {
        var _a;
        var href = link.href;
        var extension = (_a = href.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (!extension || ['pdf', 'xls', 'xlsx', 'doc', 'docx'].includes(extension)) {
            return false;
        }
        var isSameDomain = href.startsWith("http://".concat(domain)) || href.startsWith("https://".concat(domain));
        if (isSameDomain) {
            return false;
        }
        var excludedDirs = settings.excludedDirectories;
        if (excludedDirs.length > 0 && excludedDirs.some(function (dir) { return href.includes("/".concat(dir, "/")); })) {
            return false;
        }
        if (/^tel:/.test(href)) {
            return false;
        }
        return true;
    }
    function hasImageElement(element) {
        var children = element.children;
        for (var i = 0; i < children.length; i++) {
            var childElement = children[i];
            if (childElement.tagName.toLowerCase() === 'img') {
                return true;
            }
            if (childElement.children.length > 0 && hasImageElement(childElement)) {
                return true;
            }
        }
        return false;
    }
}


/***/ }),

/***/ "./src/js/modules/menu.ts":
/*!********************************!*\
  !*** ./src/js/modules/menu.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*!
 *
 *  menu.ts
 *
 */
var SiteMenu = /** @class */ (function () {
    function SiteMenu(options) {
        var _this = this;
        this.toggleMenu = function () {
            var isMenuOpen = _this.container.classList.contains('-expanded');
            var html = document.querySelector('html');
            var scrollControll = _this.scrollControll.bind(_this);
            var eventType = isMenuOpen ? 'removeEventListener' : 'addEventListener';
            var passive = { passive: false };
            var classType = isMenuOpen ? 'remove' : 'add';
            _this.btn.setAttribute('aria-pressed', "".concat(!isMenuOpen));
            // this.container.setAttribute('aria-hidden', `${isMenuOpen}`);
            _this.container.classList[classType]('-expanded');
            html.style.overflow = isMenuOpen ? 'auto' : 'hidden';
            _this.btnLabel.textContent = isMenuOpen ? 'MENU' : 'CLOSE';
            document[eventType]('touchmove', scrollControll, passive);
            _this.header.classList[classType]('-open-menu');
        };
        this.closeMenu = function () {
            _this.btn.setAttribute('aria-pressed', 'false');
            _this.btnLabel.textContent = 'MENU';
            // this.container.setAttribute('aria-hidden', 'true');
            _this.container.classList.remove('-expanded');
            document.querySelector('html').style.overflow = 'auto';
            document.removeEventListener('touchmove', _this.scrollControll);
            _this.header.classList.remove('-open-menu');
        };
        this.scrollControll = function (e) {
            var isMenuOpen = _this.container.classList.contains('-expanded');
            var inner = e.target.closest('.site-menu__body__inner');
            if (isMenuOpen) {
                if (inner) {
                    if (inner.scrollHeight > inner.clientHeight) {
                        e.stopPropagation();
                    }
                    else {
                        e.preventDefault();
                    }
                }
                else {
                    e.preventDefault();
                }
                ;
            }
            ;
        };
        this.btn = document.querySelector(options.btn);
        this.btnLabel = this.btn.querySelector(options.btnLabel);
        this.container = document.querySelector(options.container);
        this.containerName = options.container;
        this.header = document.getElementById('header');
        this.btn.addEventListener('click', this.toggleMenu);
        document.addEventListener('click', function (e) {
            if ((_this.container.classList.contains('-expanded')
                && !e.target.closest(_this.containerName)
                && !e.target.closest(options.btn))
                || e.target.classList.contains('site-menu__body')) {
                _this.closeMenu();
            }
        });
        // window.addEventListener('viewportChanged', this.viewportCheck.bind(this));
        // this.viewportCheck();
    }
    return SiteMenu;
}());
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SiteMenu);


/***/ }),

/***/ "./src/js/modules/scroll2hash.ts":
/*!***************************************!*\
  !*** ./src/js/modules/scroll2hash.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* provided dependency */ var util = __webpack_require__(/*! ./src/js/modules/utility */ "./src/js/modules/utility.ts")["default"];
/*!
 *
 *  scroll2hash.js
 *
 */
var scroll2hash = function () {
    var hash = util.hash;
    if (hash.length > 0 && !hash.includes('/')) {
        location.hash = "".concat(hash, "_");
        window.addEventListener('load', function () {
            var target = document.querySelector(hash);
            if (target) {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                var top_1 = target.getBoundingClientRect().top + scrollTop - util.scrollGap;
                setTimeout(function () {
                    window.scrollTo({ top: top_1, behavior: 'auto' });
                }, 10);
                history.replaceState(null, '', util.hash);
            }
            else {
                history.replaceState(null, '', util.hash);
            }
        });
    }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (scroll2hash);


/***/ }),

/***/ "./src/js/modules/search.ts":
/*!**********************************!*\
  !*** ./src/js/modules/search.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* provided dependency */ var util = __webpack_require__(/*! ./src/js/modules/utility */ "./src/js/modules/utility.ts")["default"];
/*!
 *
 *  search.ts
 *
 */
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.elem = document.querySelector('#search');
        this.container = this.elem.querySelector('.site-search__container');
        this.toggle = document.querySelector('#searchToggle');
        this.toggle.addEventListener('click', function (e) {
            _this.onClick(e);
        });
        util.overlay.addEventListener('click', function (e) {
            if (_this.elem.classList.contains('-expanded')
                && !e.target.closest('#search')) {
                _this.close();
            }
            ;
        });
    }
    default_1.prototype.onClick = function (e) {
        e.preventDefault();
        if (!this.elem.classList.contains('-expanded')) {
            this.toggle.setAttribute('aria-label', '検索窓を閉じる');
            this.elem.classList.add('-expanded');
            util.overlay.setAttribute('aria-hidden', 'false');
        }
        else {
            this.toggle.setAttribute('aria-label', '検索窓を開く');
            this.elem.classList.remove('-expanded');
            util.overlay.setAttribute('aria-hidden', 'true');
        }
        ;
    };
    default_1.prototype.close = function () {
        this.toggle.setAttribute('aria-label', '検索窓を開く');
        this.elem.classList.remove('-expanded');
        util.overlay.setAttribute('aria-hidden', 'true');
    };
    return default_1;
}());
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (default_1);


/***/ }),

/***/ "./src/js/modules/smooth-scroll.ts":
/*!*****************************************!*\
  !*** ./src/js/modules/smooth-scroll.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* provided dependency */ var util = __webpack_require__(/*! ./src/js/modules/utility */ "./src/js/modules/utility.ts")["default"];
/*!
 *
 *  smooth-scroll.ts
 *
 */
var smoothScrollCore = function (target, distance, duration) {
    var startTime = null;
    var startPosition = window.pageYOffset;
    var animation = function (currentTime) {
        if (startTime === null) {
            startTime = currentTime;
        }
        var timeElapsed = currentTime - startTime;
        var run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        }
    };
    var ease = function (t, b, c, d) {
        t /= d;
        return -c * Math.pow(2, -10 * t) + c + b;
    };
    requestAnimationFrame(animation);
};
var smoothScroll = function (options) {
    if (options === void 0) { options = {}; }
    var ignore = options.ignore || '[data-scroll-ignore]';
    var duration = options.duration || 700;
    var links = document.querySelectorAll("a[href^=\"#\"]:not(".concat(ignore, ")"));
    links.forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            var target = document.querySelector(link.getAttribute('href'));
            if (target) {
                var targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
                var distance = targetPosition - window.pageYOffset - util.scrollGap;
                smoothScrollCore(target, distance, duration);
            }
        });
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (smoothScroll);


/***/ }),

/***/ "./src/js/modules/utility.ts":
/*!***********************************!*\
  !*** ./src/js/modules/utility.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*!
 *
 * utility.ts
 *
 */
var BREAKPOINTS = {
    phone: 768,
    tablet: 993,
    desktop: 1220,
    largeDesktop: Infinity,
};
var gap = {
    selector: 'header',
    spselector: 'header',
    viewport: {
        phone: true,
        tablet: true,
        desktop: true,
        largeDesktop: true,
    },
};
var getViewport = function (ww) {
    if (ww < BREAKPOINTS.phone) {
        return 'phone';
    }
    else if (ww < BREAKPOINTS.tablet) {
        return 'tablet';
    }
    else if (ww < BREAKPOINTS.desktop) {
        return 'desktop';
    }
    else {
        return 'largeDesktop';
    }
};
var setScrollGap = function (viewport) {
    var gapSelector = viewport === 'phone' ? gap.spselector : gap.selector;
    var gapElement = document.getElementById(gapSelector);
    var hasGapElement = gapElement !== null;
    var gapHeight = hasGapElement ? (viewport === 'phone' || viewport === 'tablet') ? gapElement.offsetHeight : 112 : 0;
    var gapMargin = hasGapElement && viewport !== 'phone' ? 32 : 16;
    return gapHeight + gapMargin;
};
var getScrollbarWidth = function () {
    var element = document.createElement('div');
    element.style.visibility = 'hidden';
    element.style.overflow = 'scroll';
    document.body.appendChild(element);
    var scrollbarWidth = element.offsetWidth - element.clientWidth;
    document.body.removeChild(element);
    return scrollbarWidth;
};
var html = document.documentElement;
var setSize = function () {
    var vh = window.innerHeight * 0.01;
    html.style.setProperty('--vh', "".concat(vh, "px"));
    var scrollbarWidth = getScrollbarWidth();
    if (scrollbarWidth > 0) {
        html.style.setProperty('--scroll-bar', "".concat(scrollbarWidth, "px"));
    }
};
var telLinkManager = function () {
    var telLinks = document.querySelectorAll("a[href^=\"tel:\"]");
    var isPhone = /iPhone|Android/.test(navigator.userAgent);
    if (isPhone) {
        telLinks.forEach(function (link) {
            link.classList.add('u-tel', '-enabled');
        });
    }
    else {
        telLinks.forEach(function (link) {
            link.classList.add('u-tel', '-disabled');
            link.addEventListener('click', function (e) {
                e.preventDefault();
            });
        });
    }
    ;
};
var handleResize = function () {
    var newViewport = getViewport(window.innerWidth);
    if (util.viewport !== newViewport) {
        util.viewport = newViewport;
        window.dispatchEvent(viewportChanged);
    }
    util.scrollGap = setScrollGap(newViewport);
    setSize();
};
var overlay = document.createElement('div');
overlay.id = 'overlay';
overlay.classList.add('site-overlay');
var handleDomContentLoaded = function () {
    document.body.appendChild(overlay);
    overlay.classList.add('-initialized');
    util.overlay = overlay;
};
var handleLoad = function () {
    util.scrollGap = setScrollGap(util.viewport);
    telLinkManager();
    setSize();
};
var initUtil = function () {
    var initialViewport = getViewport(window.innerWidth);
    var util = {
        ww: window.innerWidth,
        wh: window.innerHeight,
        hash: location.hash,
        viewport: initialViewport,
        scroller: 'html,body',
        scrollGap: setScrollGap(initialViewport),
        isTouchDevice: 'ontouchstart' in window,
        overlay: null
    };
    if (util.isTouchDevice) {
        var body = document.body;
        body.setAttribute('ontouchstart', '');
    }
    return util;
};
var util = initUtil();
var viewportChanged = new CustomEvent('viewportChanged');
window.addEventListener('resize', handleResize, { passive: true });
document.readyState !== "loading" ? handleDomContentLoaded() : document.addEventListener("DOMContentLoaded", handleDomContentLoaded);
document.readyState !== "loading" ? handleLoad() : document.addEventListener("DOMContentLoaded", handleLoad);
window.addEventListener('load', handleLoad, { passive: true });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (util);


/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		id: moduleId,
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/******/ // expose the modules object (__webpack_modules__)
/******/ __webpack_require__.m = __webpack_modules__;
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/compat get default export */
/******/ (() => {
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = (module) => {
/******/ 		var getter = module && module.__esModule ?
/******/ 			() => (module['default']) :
/******/ 			() => (module);
/******/ 		__webpack_require__.d(getter, { a: getter });
/******/ 		return getter;
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/ensure chunk */
/******/ (() => {
/******/ 	__webpack_require__.f = {};
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = (chunkId) => {
/******/ 		return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 			__webpack_require__.f[key](chunkId, promises);
/******/ 			return promises;
/******/ 		}, []));
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/get javascript chunk filename */
/******/ (() => {
/******/ 	// This function allow to reference async chunks
/******/ 	__webpack_require__.u = (chunkId) => {
/******/ 		// return url for filenames not based on template
/******/ 		if ({"vendors-node_modules_swiper_swiper_css-node_modules_swiper_modules_index_mjs-node_modules_swi-e8ef1e":1,"top-slider":1}[chunkId]) return "" + chunkId + ".js";
/******/ 		// return url for filenames based on template
/******/ 		return undefined;
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/******/ /* webpack/runtime/make namespace object */
/******/ (() => {
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = (exports) => {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/import chunk loading */
/******/ (() => {
/******/ 	// no baseURI
/******/ 	
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// [resolve, Promise] = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		"bundle": 0
/******/ 	};
/******/ 	
/******/ 	var installChunk = (data) => {
/******/ 		var {ids, modules, runtime} = data;
/******/ 		// add "modules" to the modules object,
/******/ 		// then flag all "ids" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0;
/******/ 		for(moduleId in modules) {
/******/ 			if(__webpack_require__.o(modules, moduleId)) {
/******/ 				__webpack_require__.m[moduleId] = modules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(runtime) runtime(__webpack_require__);
/******/ 		for(;i < ids.length; i++) {
/******/ 			chunkId = ids[i];
/******/ 			if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 				installedChunks[chunkId][0]();
/******/ 			}
/******/ 			installedChunks[ids[i]] = 0;
/******/ 		}
/******/ 	
/******/ 	}
/******/ 	
/******/ 	__webpack_require__.f.j = (chunkId, promises) => {
/******/ 			// import() chunk loading for javascript
/******/ 			var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 			if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 	
/******/ 				// a Promise means "currently loading".
/******/ 				if(installedChunkData) {
/******/ 					promises.push(installedChunkData[1]);
/******/ 				} else {
/******/ 					if(true) { // all chunks have JS
/******/ 						// setup Promise in chunk cache
/******/ 						var promise = import("./" + __webpack_require__.u(chunkId)).then(installChunk, (e) => {
/******/ 							if(installedChunks[chunkId] !== 0) installedChunks[chunkId] = undefined;
/******/ 							throw e;
/******/ 						});
/******/ 						var promise = Promise.race([promise, new Promise((resolve) => (installedChunkData = installedChunks[chunkId] = [resolve]))])
/******/ 						promises.push(installedChunkData[1] = promise);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 	};
/******/ 	
/******/ 	// no external install chunk
/******/ 	
/******/ 	// no on chunks loaded
/******/ })();
/******/ 
/******/ /* webpack/runtime/nonce */
/******/ (() => {
/******/ 	__webpack_require__.nc = undefined;
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!***********************!*\
  !*** ./src/js/app.ts ***!
  \***********************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var scroll2hash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! scroll2hash */ "./src/js/modules/scroll2hash.ts");
/* harmony import */ var linker__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! linker */ "./src/js/modules/linker.ts");
/* harmony import */ var search__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! search */ "./src/js/modules/search.ts");
/* harmony import */ var menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! menu */ "./src/js/modules/menu.ts");
/* harmony import */ var smooth_scroll__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! smooth-scroll */ "./src/js/modules/smooth-scroll.ts");
/* harmony import */ var header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! header */ "./src/js/modules/header.ts");
/*!
 *
 * app.js
 *
 */
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*** ./modules **/






(0,scroll2hash__WEBPACK_IMPORTED_MODULE_0__["default"])();
function init() {
    (0,linker__WEBPACK_IMPORTED_MODULE_1__["default"])();
    (0,smooth_scroll__WEBPACK_IMPORTED_MODULE_4__["default"])({
        ignore: '[data-ignore-link], .huga a'
    });
    new search__WEBPACK_IMPORTED_MODULE_2__["default"]();
    var menu = new menu__WEBPACK_IMPORTED_MODULE_3__["default"]({
        btn: '#menuBtn',
        btnLabel: '.site-menu__btn__label',
        container: '#menuContainer'
    });
    (0,header__WEBPACK_IMPORTED_MODULE_5__["default"])();
    initTopSlider();
}
;
function initTopSlider() {
    return __awaiter(this, void 0, void 0, function () {
        var slider, TopSlider;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    slider = document.querySelector('#topSlider');
                    if (!slider) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(/*! import() | top-slider */[__webpack_require__.e("vendors-node_modules_swiper_swiper_css-node_modules_swiper_modules_index_mjs-node_modules_swi-e8ef1e"), __webpack_require__.e("top-slider")]).then(__webpack_require__.bind(__webpack_require__, /*! top-slider */ "./src/js/modules/top-slider.ts"))];
                case 1:
                    TopSlider = (_a.sent()).default;
                    TopSlider(slider);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
// async function initTab() {
// 	const tabElem = document.querySelector('.c-tab');
// 	if (tabElem) {
// 		const { default: Tab } = await import(
// 			/* webpackChunkName: "tab" */ 'tab'
// 		);
// 		Tab('.c-tab')
// 	}
// }
// async function initAccordion() {
// 	const accordionElem = document.querySelector('.p-faq');
// 	if (accordionElem) {
// 		const { default: Accordion } = await import(
// 			/* webpackChunkName: "accordion" */ 'accordion'
// 		);
// 		Accordion('.p-faq', {
// 			containerSelector: '.p-faq__item',
// 			headSelector: '.p-faq__head',
// 			bodySelector: '.p-faq__body'
// 		});
// 	}
// }
document.readyState !== "loading" ? init() : document.addEventListener("DOMContentLoaded", init);

})();

